import { Fragment, useState } from 'react';

import Slider from 'react-slick';

import { legacyTheme, styled } from '@prose-ui/legacy';

import { type StaticImageData } from 'Components/Image';

import useResponsiveVariant from 'utils/useResponsiveVariant';

import { HowItWorksCard } from './HowItWorksCard';

type MobileSliderProps = {
  cards: Card[];
};

export type Card = {
  title: string;
  description: string;
  imgSrc: StaticImageData;
  imgAlt: string;
};

const StyledSlider = styled(Slider)`
  /* top: 15%; */
  /* width: 100%; */
  .slick-track .slick-slide:last-child {
    padding-right: 16px;
  }
  .slick-track .slick-slide:first-of-type {
    padding-left: 16px;
  }
`;

const SliderCardsContainer = styled('div')`
  padding: 0 0px 0px 14px;

  ${legacyTheme.breakpoints.up('sm')} {
    padding: 0 0px 72px 16px;
  }
  ${legacyTheme.breakpoints.up('lg')} {
    padding: 0 0 72px 0;
  }
`;

export const HowItWorksMobileSlider = ({ cards }: MobileSliderProps) => {
  const { isMobile } = useResponsiveVariant();
  const [currentSlide, setCurrentSlide] = useState(0);
  const sliderCards = cards.map((card, i) => {
    return (
      <Fragment key={currentSlide}>
        <SliderCardsContainer>
          <HowItWorksCard card={card} index={i + 1} />
        </SliderCardsContainer>
      </Fragment>
    );
  });
  const slidesToShowValue = isMobile ? 1.3 : 2.5;

  return (
    <StyledSlider
      afterChange={(slide: number) => setCurrentSlide(Math.round(slide))}
      arrows={false}
      focusOnSelect
      infinite={false}
      slidesToShow={slidesToShowValue}
    >
      {sliderCards}
    </StyledSlider>
  );
};
